import { createSelector } from 'reselect';

import { WORKFLOW_ID as FINANCIAL_PLAN_WORKFLOW_ID } from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import { WORKFLOW_ID as EDUCATION_WORKFLOW_ID } from '../EducationWorkflow/EducationWorkflowConstants';
import { WORKFLOW_ID as RETIREMENT_WORKFLOW_ID } from '../RetirementWorkflow/RetirementWorkflowConstants';
import { WORKFLOW_ID as DEBT_MANAGEMENT_WORKFLOW_ID } from '../DebtManagementWorkflow/DebtManagementWorkflowConstants';
import { WORKFLOW_ID as HOME_PURCHASE_WORKFLOW_ID } from '../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { WORKFLOW_ID as EMERGENCY_FUND_WORKFLOW_ID } from '../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import { WORKFLOW_ID as LARGE_PURCHASE_WORKFLOW_ID } from '../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';

import { viewIdSelector as accountManualViewIdSelector } from '../FinancialAccountsWorkflow/Steps/AccountsManualStepSelector';
import { viewIdSelector as accountViewIdSelector } from '../AccountsWorkflow/Steps/AccountsStep/AccountsStepSelector';
import { viewIDSelector as childrenViewIdSelector } from '../ChildrenInfoWorkflow/Steps/ChildrenCRUDSelector';
import { viewIDSelector as pensionsViewIdSelector } from '../PensionWorkflow/Steps/PensionsOverviewSelector';
import { viewIdSelector as debtsViewIdSelector } from '../DebtManagementDebtsWorkflow/Steps/AccountsStep/AccountsStepSelector';
import { CHILDREN_CRUD_ADD_EDIT } from '../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';
import { PENSIONS_CRUD_ADD_EDIT } from '../PensionWorkflow/PensionWorkflowConstants';
import {
  ADD as ACCOUNTS_ADD,
  EDIT as ACCOUNTS_EDIT,
} from '../AccountsWorkflow/Steps/AccountsStep/AccountsStepViews';
import {
  ADD as DEBT_DEBTS_ADD,
  EDIT as DEBT_DEBTS_EDIT,
} from '../DebtManagementDebtsWorkflow/Steps/AccountsStep/AccountsStepViews';

const workfowIdSelector = (_, { workflowId }) => workflowId;

const hiddenForChildAndSimpleAccountsWorkflows = (childrenViewId, accountsViewId) => {
  if (childrenViewId === CHILDREN_CRUD_ADD_EDIT) {
    return true;
  }
  if (accountsViewId === ACCOUNTS_ADD || accountsViewId === ACCOUNTS_EDIT) {
    return true;
  }
  return false;
};

export const hideSelector = createSelector(
  workfowIdSelector,
  accountViewIdSelector,
  childrenViewIdSelector,
  pensionsViewIdSelector,
  debtsViewIdSelector,
  accountManualViewIdSelector,
  (
    wrkflId,
    accountsViewId,
    childrenViewId,
    pensionsViewId,
    debtsViewId,
    financialAccountsViewId,
  ) => {
    switch (wrkflId) {
      case FINANCIAL_PLAN_WORKFLOW_ID:
        if (financialAccountsViewId === ACCOUNTS_ADD || financialAccountsViewId === ACCOUNTS_EDIT) {
          return true;
        }
        return false;
      case RETIREMENT_WORKFLOW_ID:
        if (pensionsViewId === PENSIONS_CRUD_ADD_EDIT) {
          return true;
        }
        return hiddenForChildAndSimpleAccountsWorkflows(childrenViewId, accountsViewId);
      case EDUCATION_WORKFLOW_ID:
      case HOME_PURCHASE_WORKFLOW_ID:
      case LARGE_PURCHASE_WORKFLOW_ID:
        return hiddenForChildAndSimpleAccountsWorkflows(childrenViewId, accountsViewId);
      case DEBT_MANAGEMENT_WORKFLOW_ID:
      case EMERGENCY_FUND_WORKFLOW_ID:
        if (debtsViewId === DEBT_DEBTS_ADD || debtsViewId === DEBT_DEBTS_EDIT) {
          return true;
        }
        return hiddenForChildAndSimpleAccountsWorkflows(childrenViewId, accountsViewId);
      default:
        return false;
    }
  },
);

export default hideSelector;
